// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import 'jquery-ui';
$.widget.bridge('uibutton', $.ui.button);
$.widget.bridge('uitooltip', $.ui.tooltip);
import 'jquery-ui-touch-punch';

import 'bootstrap';
import '@fortawesome/fontawesome-free/js/all'
import '../stylesheets/application';
window.$ = jQuery;
window.jQuery = jQuery;

// AlertifyJS
import alertify from 'alertifyjs';
global.alertify = alertify;
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
//import 'alertifyjs/build/css/themes/semantic.min.css';
//import 'alertifyjs/build/css/themes/bootstrap.min.css';

// jBox
import jBox from 'jbox';
global.jBox = jBox;
import 'jbox/dist/jBox.all.css';

// SweetAlert2
import Swal from 'sweetalert2';
global.Swal = Swal;
import 'sweetalert2/src/sweetalert2.scss';

// Dropzone
import Dropzone from 'dropzone';
global.Dropzone = Dropzone;
import 'dropzone/dist/dropzone.css';
import 'dropzone/dist/basic.css';

// flatpickr (DatePicker)
import flatpickr from "flatpickr";
//global.flatpickr = flatpickr;
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/confetti.css';
import 'flatpickr/dist/l10n/ja.js';
import 'flatpickr/dist/plugins/monthSelect/style.css';

// Chartkick
import "chartkick"

// HTMLからコントローラ名取得
var controller = $('body').data('controller');
var action = $('body').data('action');

// ローディング非表示
window.stopload = function() {
  // ローディング画面 非表示
  $('#loading').hide();
}

// ページを離れる際のアラート
window.onbeforeunload = function(e) {
  if ($("#page_edit").val() == "ON") {
    // フォーカス外し
    document.activeElement.blur();

    e.preventDefault();
    return '';
  }
};

// EnterキーSubmit無効化
$(function(){
  $("input"). keydown(function(e) {
    //alertify.notify("keyCode="+e.keyCode, "custom", 3);
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
      return false;
    } else {
      return true;
    }
  });
});

// フォーカス外し
window.focusOut = function( id ) {

  //$("#"+id).blur();
  // フォーカス外し
  document.activeElement.blur();
}

// キャンセルボタン
window.cancelBtnClick = function() {
  alertify.notify("キャンセル", "custom", 3);
}

// サインアウトsubmit
window.signOutSubmit = function() {

  // Local Submit
  $("#destroy_user_session_form").submit();
}

// ユーザー情報モーダルsubmit
window.userModalSubmit = function( operation, user_id, auth, company_id ) {
  $("#um_operation").val( operation );
  $("#um_user_id").val( user_id );
  $("#um_auth").val( auth );
  $("#um_company_id").val( company_id );

  // Remote Submit
  Rails.fire( $("#users_modal_form")[0], "submit" );
}

// ユーザー情報操作submit
window.userOperationSubmit = function() {
  // ローディング画面 表示
  $('#loading').show();
  setTimeout('stopload()',10000);

  // Remote Submit
  Rails.fire( $("#users_operation_form")[0], "submit" );
}

// ユーザーパスワード自動変更
window.userPasswdAutoGenerateSubmit = function() {
  alertify.confirm("パスワード自動変更", "パスワードを自動で変更し、<br>新パスワードはメールにてお知らせします。<br><br>実行すると自動的にサインアウトしますので<br>ご注意ください。",
    function(){
      // user clicked "はい"
      $("#user_operation").val( "pwchg_generate" );
      // Remote Submit
      Rails.fire( $("#users_operation_form")[0], "submit" );
    },
    function(){
      // user clicked "キャンセル"
      alertify.notify("キャンセル", "custom", 3);
    }
  ).set("labels", {ok: "自動変更 実施", cancel: "キャンセル"});

  // スタイル設定
  $('.ajs-header').css({
    backgroundColor: 'aliceblue'
  });
  $('.ajs-body').css({
    backgroundColor: 'ghostwhite'
  });
  $('.ajs-footer').css({
    backgroundColor: 'aliceblue'
  });
  $('.ajs-ok').css({
    color: 'white',
    backgroundColor: 'deepskyblue'
  });
  $('.ajs-ok').hover(
    function() {
      // カーソルON
      $(this).css('background-color', 'dodgerblue')
    },
    function() {
      // カーソルOFF
      $(this).css('background-color', 'deepskyblue')
    }
  );
}

// ユーザーパスワードリセット
window.userPasswdResetSubmit = function(id, name) {
  // フォーカス外し
  document.activeElement.blur();
  /*
  alertify.confirm( "パスワードリセット確認",
                    "ユーザー["+name+"] のパスワードをリセット・自動生成し、新パスワードをメール送信します",
                    function (e) {
                      // user clicked "ok"
                      $("#upr_id").val( id );
                      // Remote Submit
                      Rails.fire( $("#user_passwd_reset_form")[0], "submit" );
                    },
                    function (e) {
                      alertify.notify("キャンセル", "custom", 3);
                    }
  ).set("labels", {ok:"リセット実行", cancel:"キャンセル"});
  */
  Swal.fire({
    title: 'パスワードリセットを実行します',
    html: "ユーザー ["+name+"] の<br>パスワードをリセット・自動生成し、<br>新パスワードをメール送信します",
    //icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#aaa',
    confirmButtonText: 'パスワードリセット',
    cancelButtonText: 'キャンセル',
    background: '#ffd700'
  }).then((result) => {
    if (result.isConfirmed) {
      // user clicked "ok"
      $("#upr_id").val( id );
      // Remote Submit
      Rails.fire( $("#user_passwd_reset_form")[0], "submit" );

    } else {
      alertify.notify("キャンセル", "custom", 3);

    }
  })
}

/***********************************************************/
/** Webプッシュ通知 **/
/***********************************************************/
/*
var CACHE_VERSION = 'v1';
var CACHE_NAME = CACHE_VERSION + ':sw-cache-';

window.onSWInstall = function(event) {
  return event.waitUntil(
    caches.open(CACHE_NAME).then(function prefill(cache) {
      return cache.addAll([]);
    })
  );
}

window.onSWActivate = function(event) {
  return event.waitUntil(
    caches.keys().then(function(cacheNames) {
      return Promise.all(
        cacheNames.filter(function(cacheName) {
          // Return true if you want to remove this cache,
          // but remember that caches are shared across
          // the whole origin
          return cacheName.indexOf(CACHE_VERSION) !== 0;
        }).map(function(cacheName) {
          return caches.delete(cacheName);
        })
      );
    })
  );
}

window.onSWPush = function(event) {
  // event.data are null when Firefox's debugger push
  // event.data are PushMessageData object and cannot exec event.data.json, event.data.text => 'Test push message from DevTools.'
  var json = event.data ? event.data.json() : {"title" : "DEBUG TITLE", "body" : "DEBUG BODY"};
  return event.waitUntil(
    self.registration.showNotification(json.title, {
      body: json.body,
      //icon: json.icon,
      data: {
        target_url: json.target_url
      }
    })
  );
}

window.onSWNotificationClick = function(event) {
  event.notification.close();
  return event.waitUntil(
    clients.openWindow(event.notification.data != null ? event.notification.data.target_url : '/')
  );
}

self.addEventListener('install', onSWInstall);
self.addEventListener('activate', onSWActivate);
self.addEventListener("push", onSWPush);
self.addEventListener("notificationclick", onSWNotificationClick);
*/
